export enum UnitSystem {
  USC = 'USC',
  SI = 'SI'
}